import {
  Image,
  SimpleModal,
  TextInputField,
  Flex,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { FC } from 'react'
import {
  BorderRadius6,
  GreyGrey10,
  GreyGrey70,
  GreyGrey80,
  GreyGrey90,
  Primary13SemiBold,
  Primary13Regular
} from '@sequencehq/core-components'
import Spinner from 'components/Loading/Spinner'
import { useLinkSalesforceCustomerModal } from './useLinkSalesforceCustomerModal'
import salesforceAccountIcon from './salesforceAccountIcon.svg'

export const LinkSalesforceCustomerModal: FC<{
  onLink?: () => void
  onClose: () => void
  customerId: string
}> = props => {
  const hook = useLinkSalesforceCustomerModal({
    onConfirm: props.onLink,
    customerId: props.customerId
  })

  return (
    <SimpleModal
      isOpen
      onClose={props.onClose}
      data-testid="salesforce.account.link.modal"
      title={`Link ${hook.customerName} to ${hook.serviceName} account`}
      isLoading={!hook.loaded}
      submitButtonText="Create link"
      submittingButtonText="Creating link..."
      cancelButtonText="Cancel"
      submitDisabled={hook.submit.disabled}
      submitting={hook.submit.linking}
      onSubmit={hook.submit.onClick}
      minHeight="0px"
    >
      <Flex
        color={GreyGrey80}
        {...Primary13Regular}
        flexDirection="column"
        gap="16px"
      >
        <TextInputField
          value={hook.fields.linkToAccount.value}
          onChange={e => hook.fields.linkToAccount.onChange(e.target.value)}
          validationErrors={hook.fields.linkToAccount.validationErrors}
          label={`${hook.serviceName} ID or URL`}
          placeholder={`e.g. 0000U00000ABC0DEFG`}
          data-testid="linkToAccount"
        />
        {hook.externalDetails.show && hook.externalDetails.fetching && (
          <Grid
            gridTemplateColumns="auto 1fr"
            gridColumnGap="8px"
            backgroundColor={GreyGrey10}
            borderRadius={BorderRadius6}
            padding="12px"
          >
            <GridItem>
              <Spinner height="16px" width="16px" color={GreyGrey70} />
            </GridItem>
            <GridItem {...Primary13SemiBold} color={GreyGrey70}>
              Fetching account information
            </GridItem>
          </Grid>
        )}
        {hook.externalDetails.show && !hook.externalDetails.fetching && (
          <Grid
            gridTemplateColumns="auto 1fr"
            gridColumnGap="8px"
            backgroundColor={GreyGrey10}
            borderRadius={BorderRadius6}
            padding="12px"
            alignItems="center"
          >
            <Flex
              alignItems="center"
              justifyContent="center"
              height="20px"
              width="20px"
              borderRadius="1.667px"
              backgroundColor="#5867E8"
            >
              <Image src={salesforceAccountIcon} height="12px" width="12px" />
            </Flex>
            <GridItem
              {...Primary13SemiBold}
              color={GreyGrey90}
              data-testid="salesforce.account.link.modal.externalName"
            >
              {hook.externalDetails.name}
            </GridItem>
          </Grid>
        )}
      </Flex>
    </SimpleModal>
  )
}
